var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.visible)?_c('ChooseRole',{attrs:{"roleList":_vm.fpidData.user_data,"roleId":_vm.authData.role_id},on:{"close":function($event){_vm.visible = false},"chooseRole":_vm.chooseRoleHandler}}):_vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }